import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DwhoExportDataService } from 'src/app/services/dwho-export-data.service';
import { DatePipe } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/services/notification.service';
@Component({
  selector: 'app-export-data-dialog',
  templateUrl: './export-data-dialog.component.html',
  styleUrls: ['./export-data-dialog.component.scss'],
  standalone: false,
})
export class ExportDataDialogComponent {
  startDate: Date | undefined = undefined;
  endDate: Date | undefined = undefined;
  tooltipBehavior = '';
  isLoading = false;
  templateDate = 'yyyy-MM-dd';

  constructor(
    private dialogRef: MatDialogRef<ExportDataDialogComponent>,
    private dwhoExportDataService: DwhoExportDataService,
    private datePipe: DatePipe,
    private notificationService: NotificationService
  ) {}

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  buildTooltip(): string {
    this.tooltipBehavior =
      this.endDate && this.startDate
        ? 'Se descargará la información en un archivo con formato .xlsx'
        : 'Debe seleccionar las fechas del periodo de tiempo que desea descagar';

    return this.tooltipBehavior;
  }

  async validatDataAndDownloadFile(): Promise<void> {
    const startDateParsed = this.datePipe.transform(
      this.startDate,
      this.templateDate
    );
    const endDateParsed = this.datePipe.transform(
      this.endDate,
      this.templateDate
    );

    if (startDateParsed && endDateParsed) {
      this.dwhoExportDataService
        .validateData(startDateParsed, endDateParsed)
        .subscribe((response: any) => {
          if (response.hasData) {
            this.getFile(startDateParsed, endDateParsed);
          } else {
            this.notificationService.notify(response.message, false);
          }
        });
    }
  }

  async getFile(startDateParsed: string, endDateParsed: string): Promise<void> {
    this.dwhoExportDataService
      .getDwhoData(startDateParsed, endDateParsed)
      .subscribe((response: HttpResponse<Blob>) => {
        this.downLoadFile(response);
      });
  }

  private downLoadFile(response: HttpResponse<Blob>) {
    const fileName =
      response.headers.get('content-disposition')?.split('filename=')[1] ||
      'DB_EXPORT_BPM-DWHO_EXPORT.xlsx';
    if (response && response.body) {
      const blob = new Blob([response.body], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const f = document.createElement('a');
      f.href = window.URL.createObjectURL(blob);
      f.download = fileName;
      f.click();
    } else {
      this.notificationService.notify(
        'Ocurrió un error al itentar descargar el archivo excel.',
        false
      );
    }
  }
}
